// @flow
import type { Message } from '../create'

/**
 * Append values to the message object. These values will be used while
 * formatting the message as default values if no new values to the component
 * were provided.
 * @param  {Message} message
 * @param  {Object} values
 * @return {Message}
 */
function withValues(message: Message, values: Object): Message {
  return {
    ...message,
    values,
  }
}

export default withValues
